import React from "react";
import { useParams } from "react-router-dom";
import { RegisterLayoutHandler } from "../../pages/layouts/RegisterLayoutHandler";

export const GenericRegister = () => {
  const { source } = useParams();
  return <RegisterLayoutHandler key={source} source={source} />;
};
